import { FC } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import { TypeMargin, TypeSize } from '@/core/types'
import { cn } from '@bem-react/classname'
import { v4 as uuidv4 } from 'uuid'

import { Message } from '@/components/UI/Message'

import './FieldPhone.scss'

const cnFieldPhone = cn('FieldPhone')

export interface IFieldPhone {
  label?: string
  errors?: string
  placeholder?: string
  classNameInput?: string
  classNameLabel?: string
  disabled?: boolean
  sizeInput?: TypeSize
  mb?: TypeMargin
  value?: string
  className?: string
  onChange?: (v?: string) => void
}

export const FieldPhone: FC<IFieldPhone> = ({
  value,
  label,
  onChange,
  errors,
  placeholder,
  className,
  classNameLabel,
  // sizeInput = 'md',
  mb = 'md',
}) => {
  return (
    <div
      className={cnFieldPhone(
        {
          xxl: mb === 'xxl',
          xl: mb === 'xl',
          lg: mb === 'lg',
          md: mb === 'md',
          sm: mb === 'sm',
          none: mb === 'none',
        },
        [className],
      )}
    >
      {label && (
        <label
          htmlFor={'input-' + uuidv4()}
          className={cnFieldPhone(
            'label',
            {
              error: !!errors,
            },
            [classNameLabel],
          )}
        >
          {label}
        </label>
      )}

      <div className={cnFieldPhone('wrap')}>
        <PhoneInput
          country={'us'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          inputClass={cnFieldPhone('input')}
          containerClass={cnFieldPhone('container')}
          buttonClass={cnFieldPhone('button')}
        />
      </div>

      <Message
        className={cnFieldPhone('error')}
        text={errors}
        type='error'
        open={!!errors}
      />
    </div>
  )
}
